import React from 'react';

import { getImgixSrc } from '@utils/images';

const LetterFromEditor = () => {
  return (
    <div className="flex w-full flex-col sm:block">
      <figure className="order-2 mx-auto mb-24 mt-24 max-w-[272px] sm:order-1 sm:float-right sm:ml-[69px] sm:mr-0 sm:mt-0 sm:max-w-[255px] md:ml-[108px] md:max-w-[382px] lg:max-w-[409px]">
        <img
          src={getImgixSrc({
            path: 'about/Jessica_Lessin.png',
            isEnvDependent: false,
          })}
          className="aspect-[16/9] w-full max-w-full object-cover object-[0_35%] sm:aspect-[auto] sm:object-center"
          alt="A photo of Founder & CEO Jessica Lessin"
        />
      </figure>
      <h2 className="mb-24 mt-0 font-suisse-screen text-headline-alt-sm md:text-headline-lg">
        Letter from the editor
      </h2>
      <p className="mt-0 font-suisse-neue text-body-md md:text-body-lg">
        We founded The Information in late 2013 with a simple idea: write deeply reported articles
        about the technology industry that you won&apos;t find elsewhere.
      </p>
      <p className="mt-0 font-suisse-neue text-body-md md:text-body-lg">
        Since then, we&apos;ve moved markets, gotten the early scoop on billions of dollars of
        acquisitions and told you what&apos;s happening deep inside companies like Apple, Facebook
        and Google. Our stories have been followed by the Wall Street Journal, the New York Times,
        Bloomberg and other major outlets thousands of times. How we compete is simple. We recruit
        the best reporters, give them the freedom to write about important topics and tell them not
        to worry about the small stuff.
      </p>
      <p className="mt-0 font-suisse-neue text-body-md md:text-body-lg">
        Because our articles are deeply reported and written for an engaged audience, they have real
        impact. Our coverage of the secret terms of VC deals—and what they mean for employees—has
        reshaped how some investors and companies approach those deals. And our Future List project
        about the lack of diversity among tech investors has been cited by more than a hundred
        publications.
      </p>
      <p className="mt-0 font-suisse-neue text-body-md md:text-body-lg">
        Quality stories breed quality subscribers. As our subscriber community grows, we&apos;re
        investing aggressively in our team and reporting. We believe this formula is far more
        scalable than relying on traffic or conferences, and it&apos;s totally—100 percent—aligned
        with our readers.
      </p>
      <p className="mt-0 font-suisse-neue text-body-md md:text-body-lg">
        Unlike most other news sites, we don’t have venture capital or corporate owners. I own the
        publication. Like other publications, we do sometimes do business deals with companies that
        we cover, such as event sponsorships. Those never affect coverage.
      </p>
      <p className="mt-0 font-suisse-neue text-body-md md:text-body-lg">
        If you have any questions about us, our business or our team, we&apos;d love to hear from
        you at hello@theinformation.com. Thank you for your interest in what we&apos;re building.
      </p>

      <figure className="ml-0 mt-32">
        <img
          src={getImgixSrc({
            path: 'about/signature_JL.svg',
            isEnvDependent: false,
          })}
          className="max-w-[320px] sm:aspect-[auto] sm:object-center"
          alt="A photo of Founder & CEO Jessica Lessin"
        />
        <figcaption>
          <p className="my-0 mt-16 font-suisse-screen text-byline-lg">Founder & CEO</p>
        </figcaption>
      </figure>
    </div>
  );
};

export default LetterFromEditor;
